/* mp-sticky-bar-base.js — shared scroll-triggered reveal behavior for native
   sticky bars (PDP buy bar + Cart checkout bar). Shows the given bar once the
   given threshold element has scrolled above the viewport, hides it again
   once that element is back in view. */
window.mpStickyBar = window.mpStickyBar || {};
window.mpStickyBar.watch = function (barEl, thresholdEl) {
  if (!barEl || !thresholdEl) return;

  function update() {
    var rect = thresholdEl.getBoundingClientRect();
    var pastThreshold = rect.bottom < 0;
    barEl.classList.toggle('mp-sticky-bar--visible', pastThreshold);
    // The bar is position:fixed at the bottom of the viewport, so once visible
    // it sits on top of whatever page content (e.g. the site footer) is
    // currently scrolled to the bottom. Reserve that space in the document
    // flow so the bar never overlaps real footer content underneath it.
    document.body.style.paddingBottom = pastThreshold ? barEl.offsetHeight + 'px' : '';
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
};
